import './chip-group.css';
export default {
  "chipGroup": "pf-v5-c-chip-group",
  "chipGroupClose": "pf-v5-c-chip-group__close",
  "chipGroupLabel": "pf-v5-c-chip-group__label",
  "chipGroupList": "pf-v5-c-chip-group__list",
  "chipGroupListItem": "pf-v5-c-chip-group__list-item",
  "chipGroupMain": "pf-v5-c-chip-group__main",
  "modifiers": {
    "category": "pf-m-category"
  }
};